import { render, staticRenderFns } from "./SendSingle.vue?vue&type=template&id=52a5eeb4"
import script from "./SendSingle.vue?vue&type=script&lang=js"
export * from "./SendSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports